import { render } from "./SimpleNoteDetailTabHistory.vue?vue&type=template&id=229e252f"
import script from "./SimpleNoteDetailTabHistory.vue?vue&type=script&lang=js"
export * from "./SimpleNoteDetailTabHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__